import { ref, computed, Ref } from 'vue'

export const expandFn = (data: any[] = [], config: any) => {
  const { showExpand, expandConfigId, dataFormatFn } = config.value
  data = (dataFormatFn ? dataFormatFn(data) : data) ?? []
  for (const t of data) {
    if (showExpand) {
      t.expandFlag = false
    }
    if (expandConfigId) {
      t.noExpand = !(t[expandConfigId] && (t[expandConfigId] !== '-') && t[expandConfigId].length > 0)
    }
  }
  return data
}
export default function (tableData: any, config: any, emits: any) {
  const expandFlag = ref(false)
  const expandRowKeys: Ref<number[]> = ref([])
  const { showExpand, rowKey } = config.value
  const isAllExpand = () => expandRowKeys.value.length === tableData.value.length
  const isExpand = (id: any) => expandRowKeys.value.includes(id)
  const isAnimation = (row?: { expandFlag: boolean; } | undefined) => {
    if (row) {
      if (!row.expandFlag) row.expandFlag = true
      if (!expandFlag.value && onceAllExpend !== isAllExpand()) expandFlag.value = true
    } else {
      tableData.value.forEach((row: { expandFlag: boolean }) => { if (!row.expandFlag) row.expandFlag = true })
      if (!expandFlag.value) expandFlag.value = true
    }
  }

  const onceAllExpend = isAllExpand()

  const setExpandAll = (flag:boolean) => {
    if (flag) {
      expandRowKeys.value = tableData.value.filter((e:any) => !e.noExpand).map((e: { [x: string]: any }) => e[rowKey])
    } else {
      expandRowKeys.value = []
    }
  }

  const setExpandRow = (id: number, flag:boolean) => {
    if (flag) {
      expandRowKeys.value.push(id)
    } else {
      expandRowKeys.value.splice(expandRowKeys.value.indexOf(id), 1)
    }
  }

  const expandAllChange = () => {
    const expandAllFlag = !isAllExpand()
    setExpandAll(expandAllFlag)
    isAnimation()
    console.log(expandRowKeys.value, expandAllFlag)
    emits('expand-all', expandRowKeys.value, expandAllFlag)
  }
  const expandRowChange = (row: { expandFlag: boolean; [x: string]: any; }) => {
    console.log('rowKey', rowKey)
    const expandRowFlag = !isExpand(row[rowKey])
    setExpandRow(row[rowKey], expandRowFlag)
    isAnimation(row)
    emits('expand-row', row, expandRowFlag)
  }

  const isAllFilp = computed(() => isAllExpand())
  const isAnimationAllFilp = computed(() => expandFlag.value && isAllExpand())
  const isAnimationAllBack = computed(() => expandFlag.value && !isAllExpand())
  const isFilp = (row: { [x: string]: any; }) => isExpand(row[rowKey])
  const isAnimationFilp = (row: { expandFlag: boolean; [x: string]: any; }) => row.expandFlag && isExpand(row[rowKey])
  const isAnimationBack = (row: { expandFlag: boolean; [x: string]: any; }) => row.expandFlag && !isExpand(row[rowKey])
  return {
    expandRowKeys: showExpand ? expandRowKeys : undefined,
    expandAllChange: showExpand ? expandAllChange : undefined,
    expandRowChange: showExpand ? expandRowChange : undefined,
    setExpandAll: showExpand ? setExpandAll : undefined,
    setExpandRow: showExpand ? setExpandRow : undefined,
    isAllFilp: showExpand ? isAllFilp : undefined,
    isAnimationAllFilp: showExpand ? isAnimationAllFilp : undefined,
    isAnimationAllBack: showExpand ? isAnimationAllBack : undefined,
    isFilp: showExpand ? isFilp : undefined,
    isAnimationFilp: showExpand ? isAnimationFilp : undefined,
    isAnimationBack: showExpand ? isAnimationBack : undefined
  }
}
